import { IChatStoreModel } from './interfaces';

export const chatSelectors = {
    getIsLoading: (state: IChatStoreModel) => state.isLoading,
    getError: (state: IChatStoreModel) => state.error,
    getAuth: (state: IChatStoreModel) => ({
        userId: state.userId,
        nickname: state.nickname,
        isLoggedIn: state.isLoggedIn,
        isBanned: state.isBanned,
        isJoinedChannel: !!state.channelId,
    }),
};
